export const accountAnalyticAction = {
  changeFilter: (state, action) => {
    const { type, value } = action.payload;
    state[type] = value;
  },
};
